import { pipe, concat, join, map, toPairs, filter, last } from 'ramda';
import * as Sentry from '@sentry/browser';

export const buildQueryString = (paramObj, literal = '') => pipe(
  toPairs,
  filter(last),
  map(join('=')),
  concat([literal]),
  join('&'),
  concat('?'),
)(paramObj);

export const getSource = () => {
  let source = 'web';
  if (navigator.userAgent.match(/OLX-Source/)) {
    if (navigator.userAgent.match(/android/)) {
      source = 'android';
    } else if (navigator.userAgent.match(/(iOS|iPhone)/i)) {
      source = 'ios';
    } else {
      source = 'app';
    }
  } else if (
    navigator.userAgent.match(/(iOS|iPhone|Android)/i)
  ) {
    source = 'msite';
  }
  return source;
};

export const filterAbTestFromCookies = values => values
  .split('.')
  .filter(abTest => abTest.startsWith('payg') || abTest.startsWith('ppf') || abTest.startsWith('sxp'))
  .join('.');

const buildTestABExpiresAt = () => {
  const now = new Date();
  now.setTime(now.getTime() + (30 * 60 * 1000));
  return `expires=${now.toUTCString()}`;
};

export const getTestABGroups = () => {
  const testABGroups = document.cookie.match(/TestAB_Groups=([^;]*)/);
  if (testABGroups && testABGroups.length >= 2) {
    const abTestValuesFiltered = filterAbTestFromCookies(testABGroups[1]);
    document.cookie = `TestAB_Groups=${abTestValuesFiltered};${buildTestABExpiresAt()};domain=.olx.com.br;path=/`;
  }
};

export const getABTestVariant = (experimentName) => {
  try {
    const cookies = document.cookie;
    if (!cookies) {
      return null;
    }

    const experiments = document.cookie.match(/TestAB_Groups=([^;]*)/)
      .filter(c => c.includes(experimentName));

    if (!experiments || (experiments && experiments.length === 0)) {
      return null;
    }

    const variant = experiments[0]
      .split('.')
      .filter(e => e.includes(experimentName))[0]
      .split('=')[0]
      .split('_')[1]
      .replace(';', '');

    return variant;
  } catch (err) {
    Sentry.captureMessage('Error while trying to get ab experiment variant', err.message);
    return null;
  }
};

export const isWebview = () => navigator.userAgent.match(/OLX-Source/) && navigator.userAgent.match(/iOS|iPhone|Android/);

export const isNotWebview = !isWebview();

export default {
  getSource,
  buildQueryString,
  getABTestVariant,
  isWebview,
  isNotWebview,
};
